import { FeaturedArticlePreview, TopicArticlePreview } from "./articles";
import { cleanObj } from "./utils";

const url = "/api/v1/topics";

export type TopicsIndexResponse = TopicPreview[];

export const topicsIndexQuery = () => ({
  url: url,
  method: "GET",
});

export type Topic = {
  _id: string;
  articles: TopicArticlePreview[];
  dek: string;
  featuredArticle: FeaturedArticlePreview;
  heroImageAlt: string;
  heroImageSrc: string;
  imageAlt: string;
  imageSrc: string;
  metaDescription: string;
  metaTitle: string;
  pageTitle: string;
  shortDescription?: string;
  slug: string;
  title: string;
};

export type TopicPreview = {
  _id: string;
  imageAlt: string;
  imgSrc: string;
  shortDescription?: string;
  slug: string;
  title: string;
};

export interface TopicsShowParams {
  slug: string;
}

export const topicsShowQuery = ({ slug, ...params }: TopicsShowParams) => ({
  url: `${url}/${slug}`,
  method: "GET",
  params: cleanObj(params),
});
